/* eslint-disable no-nested-ternary */
/* eslint-disable no-param-reassign */
import { IAggregatedPosition } from "../../interfaces/positions";

export const aggregatePositions = (
  positions: IAggregatedPosition[]
): IAggregatedPosition[] => {
  const mapper: { [key: string]: IAggregatedPosition } = {};
  positions.forEach((position) => {
    const { instrument_name, contracts } = position;
    if (mapper[instrument_name]) {
      if (position.side === "buy") {
        mapper[instrument_name].theta -= position.theta;
      } else {
        mapper[instrument_name].theta += position.theta;
      }

      mapper[instrument_name].contracts += contracts || 0;
      mapper[instrument_name].delta += position.delta;
      mapper[instrument_name].gamma += position.gamma;
      mapper[instrument_name].vega += position.vega;
      mapper[instrument_name].pnl += position.pnl || 0;
      mapper[instrument_name].side = contracts > 0 ? "buy" : "sell";

      // Aggregate source-specific data
      if (position.aevoDelta !== undefined) {
        mapper[instrument_name].aevoDelta = (mapper[instrument_name].aevoDelta || 0) + position.aevoDelta;
      }
      if (position.binanceDelta !== undefined) {
        mapper[instrument_name].binanceDelta = (mapper[instrument_name].binanceDelta || 0) + position.binanceDelta;
      }
      if (position.bybitDelta !== undefined) {
        mapper[instrument_name].bybitDelta = (mapper[instrument_name].bybitDelta || 0) + position.bybitDelta;
      }
      if (position.hyperliquidDelta !== undefined) {
        mapper[instrument_name].hyperliquidDelta =
          (mapper[instrument_name].hyperliquidDelta || 0) + position.hyperliquidDelta;
      }
      if (position.lighterDelta !== undefined) {
        mapper[instrument_name].lighterDelta =
          (mapper[instrument_name].lighterDelta || 0) + position.lighterDelta;
      }
      if (position.lighterMainnetDelta !== undefined) {
        mapper[instrument_name].lighterMainnetDelta =
          (mapper[instrument_name].lighterMainnetDelta || 0) + position.lighterMainnetDelta;
      }
      // For mark prices, use the latest non-zero value
      if (position.aevoMarkPrice !== undefined && position.aevoMarkPrice !== 0) {
        mapper[instrument_name].aevoMarkPrice = position.aevoMarkPrice;
      }
      if (position.binanceMarkPrice !== undefined && position.binanceMarkPrice !== 0) {
        mapper[instrument_name].binanceMarkPrice = position.binanceMarkPrice;
      }
      if (position.bybitMarkPrice !== undefined && position.bybitMarkPrice !== 0) {
        mapper[instrument_name].bybitMarkPrice = position.bybitMarkPrice;
      }
      if (position.hyperliquidMarkPrice !== undefined && position.hyperliquidMarkPrice !== 0) {
        mapper[instrument_name].hyperliquidMarkPrice = position.hyperliquidMarkPrice;
      }
      if (position.lighterMarkPrice !== undefined && position.lighterMarkPrice !== 0) {
        mapper[instrument_name].lighterMarkPrice = position.lighterMarkPrice;
      }
      if (position.lighterMainnetMarkPrice !== undefined && position.lighterMainnetMarkPrice !== 0) {
        mapper[instrument_name].lighterMainnetMarkPrice = position.lighterMainnetMarkPrice;
      }
    } else {
      mapper[instrument_name] = { ...position };
    }
  });

  return Object.values(mapper);
};
